<script>
  export let query;
</script>

<div class="flex flex-col items-center text-brand-blue mb-l">
  <p class="text-b2 lg:text-b1 max-w-[180px] lg:max-w-none text-center mb-l">Your search "{query}" didn't match any results</p>
  <a href="/" class="lg:text-b3-mobile underline">Look at other items in our store</a>
</div>
